import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import de from './language/de.json';
import en from './language/en.json';
import zh from './language/zh.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    de: {
      translation: de,
    },
    zh: {
      translation: zh,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  debug: true,

  ns: ['translation'],
  defaultNS: 'translation',

  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
});

export default i18n;
